import { getTimezone } from "../../../../assets/js/src/general/utils.js";

const LOCALE_WHITELIST = ["en-GB", "en-US"];
const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
export const LOCALE = LOCALE_WHITELIST.includes(userLocale)
  ? userLocale
  : "en-GB";

export const formatDate = (timestamp, options = {}) => {
  const date = new Date(timestamp * 1000);
  const formattedDate = date.toLocaleDateString(LOCALE, {
    weekday: "short",
    day: "numeric",
    month: "long",
    timeZone: options.timeZone || getTimezone(),
    ...options,
  });
  return formattedDate;
};

export const formatActivityDate = (timestamp) =>
  formatDate(timestamp, { month: "short", year: "numeric" });

export const formatActivityTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleTimeString(LOCALE, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const extractGetSearchesEmails = (data) => {
  const ret = new Set();

  const candidateId = Object.keys(data?.results || {})[0];
  if (!candidateId || !data.results[candidateId]) return ret;

  Object.values(data.results[candidateId]).forEach((result) => {
    ["personalEmails", "workEmails"].forEach((key) => {
      result.emails[key].forEach((emailObj) => {
        ret.add(emailObj.email);
      });
    });
  });
  return ret;
};
